import JsEnabledFunction from './Components/JsEnabled'
import Parallax from './Components/Parallax'
import MainNavigation from './Components/MainNavigation'
import Hamburger from './Components/Hamburger'
import BackToTopButton from './Components/BackToTopButton'
import SearchLayer from './Components/SearchLayer'
import Switch from './Components/Switch'

const ready = (callback) => {
  if (document.readyState !== 'loading') callback()
  else document.addEventListener('DOMContentLoaded', callback)
}

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)') === true ||
  window.matchMedia('(prefers-reduced-motion: reduce)').matches === true

ready(() => {
  JsEnabledFunction()

  if (!reducedMotion) {
    const parallax = new Parallax()
    parallax.init()
  }

  const mainNavigation = new MainNavigation()
  mainNavigation.init()

  const hamburger = new Hamburger()
  hamburger.init()

  const backToTopButton = new BackToTopButton()
  backToTopButton.init()

  const searchLayer = new SearchLayer()
  searchLayer.init()

  Switch()
})
